function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { dividerClasses } from '@mui/material/Divider';
import clsx from 'clsx';
import { object, string } from 'prop-types';
import MenuItem, { menuItemClasses } from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import { getFocusStyles } from '../internals/utils';
const StyledMenuItem = styled(MenuItem)(_ref => {
  let {
    theme: {
      palette,
      spacing,
      typography
    }
  } = _ref;
  return {
    ["&.".concat(menuItemClasses.root)]: {
      color: palette.text.primary,
      fontSize: typography.body1.fontSize,
      minHeight: spacing(4.5),
      paddingBottom: spacing(1),
      paddingLeft: spacing(2),
      paddingRight: spacing(2),
      paddingTop: spacing(1),
      ["&.".concat(menuItemClasses.selected)]: {
        backgroundColor: palette.action.selected
      },
      ["&+.".concat(dividerClasses.root)]: {
        marginBottom: 0,
        marginTop: 0
      }
    },
    '&:focus-visible': {
      ...getFocusStyles({
        offset: -2
      })
    }
  };
});
const SovosMenuItem = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className,
    classes,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(StyledMenuItem, _extends({
    className: clsx('sovosMenuItem', className, classes === null || classes === void 0 ? void 0 : classes.root),
    ref: ref
  }, props));
});
SovosMenuItem.propTypes = {
  /**
   * Override or extend the styles applied to the component
   */
  classes: object,
  /**
   * Extend the class name applied to the root element
   */
  className: string
};
SovosMenuItem.baseComponent = {
  name: 'Menu Item',
  link: 'https://material-ui.com/components/menus/'
};
export default SovosMenuItem;